import { Component, OnInit, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

import { FieldType } from '@ngx-formly/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

import { MessageService } from '@app/shared/services/message.service';

import { OutputDialogComponent } from '@app/features/questionnaires/questionnaire/dialogs/output-dialog/output-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'db-custom-field-health-and-safety-responsibilities',
  templateUrl:
    './custom-field-health-and-safety-responsibilities.component.html',
  styleUrls: [
    './custom-field-health-and-safety-responsibilities.component.scss'
  ]
})

export class CustomFieldHealthAndSafetyResponsibilitiesComponent extends FieldType implements OnInit {
  public newBulkUpdateDialogRef: MatDialogRef<OutputDialogComponent>;
  public outputValues = new FormControl();
  public responsibilitiesDropdownList: any[] = [];
  public responsibilitiesDropdownSettings = {};
  public dropID;
  public routeUrl: string;

  constructor(
    private dialog: MatDialog,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {
    super();
  }

  public ngOnInit(): void {
    this.dropID = this.id + '_Drop';
    this.getRouteURLId();
    this.initializeDropdown();

    this.setOutputValuesData();

    const linkedHealthAndSafetyResponsibilitiesQuestionField = this.form.get(this.field['linkedHealthAndSafetyResponsibilitiesQuestion']);

    if (linkedHealthAndSafetyResponsibilitiesQuestionField) {
      linkedHealthAndSafetyResponsibilitiesQuestionField.valueChanges.subscribe((v: any) => {
        this.initializeDropdown();
      });
    }
  }

  public initializeDropdown(): void {
    this.responsibilitiesDropdownSettings = {
      idField: 'id',
      textField: 'abbreviation',
      singleSelection: false,
      itemsShowLimit: 2
    };

    const linkedID = this.field['linkedHealthAndSafetyResponsibilitiesQuestion'];

    const dropData = this.model[linkedID];
    if(dropData) {
      this.responsibilitiesDropdownList = dropData.responsibleRoles;
    }
  }

  public calculateResponsibilitiesVisibilty() {
    return this.formControl.value === 'Yes' ? true : false;
  }

  public editField(field): void {
    this.messageService.sendMessage(field.key);
  }

  public deleteField(field): void {
    this.messageService.sendMessage('delete:' + field.id);
  }

  public setOutputValuesData(): void {
    this.outputValues = new FormControl(this.extractOutputValues());
  }

  public editOutputTextDialog(): void {
    this.dialog.open(OutputDialogComponent, {
      width: '930px',
      panelClass: 'db-dialog',
      data: [this.field.templateOptions.multipleOutputs, this.routeUrl, this.model, this.field]
    }).afterClosed().subscribe(data => {
      if (data) {
        this.model = data;
        this.markFormAsDirty();
      }
    });
  }

  public markFormAsDirty(): void {
    this.form.markAsDirty();
  }

  private extractOutputValues(): string {
    return this.field.templateOptions.multipleOutputs.map((element: any) => {
      return element['output'].toString();
    });
  }

  private getRouteURLId(): Subscription {
    return this.route.params.subscribe(params => {
      return this.routeUrl = params.id;
    });
  }
}
